import { css } from '@emotion/react'
import * as O from 'effect/Option'
import type { CSSProperties } from 'react'
import SimpleBar from 'simplebar-react'

import { mediaQuery } from '~/@common/styles/mediaQuery'
import ConceptChipOfMiddleChapter from '~/@pages/student/challenge/@widget/ConceptChipOfMiddleChapter/ConceptChipOfMiddleChapter'
import { EmptyCaseInChallenge } from '~/@pages/student/challenge/@widget/EmptyCaseInChallenge'

export type ChallengeContentsProps = {
  isEmpty: boolean
  middleChapterIds: O.Option<readonly number[]>
  selectedMiddleChapterId: number | null
  innerStyle: CSSProperties
  innerRef: (el: HTMLDivElement | null) => void
  scrollableRef?: (el: HTMLElement | null) => void
}

const ChallengeContents = ({
  isEmpty,
  middleChapterIds,
  selectedMiddleChapterId,
  innerStyle,
  innerRef,
  scrollableRef,
}: ChallengeContentsProps) => {
  if (isEmpty) {
    return (
      <article css={_styles}>
        <div className="inner-contents" style={innerStyle} ref={innerRef}>
          <EmptyCaseInChallenge />
        </div>
      </article>
    )
  }

  return (
    <article css={_styles}>
      <div className="inner-contents" style={innerStyle} ref={innerRef}>
        <SimpleBar style={{ maxHeight: '100%' }} scrollableNodeProps={{ ref: scrollableRef }}>
          {O.match(middleChapterIds, {
            onNone: () => <EmptyCaseInChallenge />,
            onSome: (ids) => {
              return ids.map((id) => (
                <ConceptChipOfMiddleChapter
                  key={`${id}`}
                  middleChapterId={id}
                  selectedMiddleChapterId={selectedMiddleChapterId}
                />
              ))
            },
          })}
        </SimpleBar>
      </div>
    </article>
  )
}

export default ChallengeContents

const _styles = css`
  flex: 1;
  overflow-y: hidden;

  .inner-contents {
    position: relative;
    height: 100%;
  }

  ${mediaQuery.underTablet} {
    flex: unset;
    overflow: visible;

    .inner-contents {
      height: auto;
    }
  }
`
